<template>
  <div class="filter-presets">
    <Select
      :model-value="selectedPresetId"
      :options="presetOptions"
      option-label="label"
      option-value="value"
      placeholder="Saved filters"
      show-clear
      class="filter-presets__select"
      :loading="loadingPresets"
      title="Apply a saved filter set"
      @update:model-value="$emit('apply', $event)"
    />
    <Button
      type="button"
      icon="pi pi-save"
      severity="secondary"
      outlined
      size="small"
      :loading="savingPreset"
      aria-label="Save current filters as preset"
      title="Save current filters"
      @click="saveDialogVisible = true"
    />
    <Button
      v-if="selectedPresetId"
      type="button"
      icon="pi pi-trash"
      severity="secondary"
      text
      size="small"
      aria-label="Delete preset"
      title="Delete selected preset"
      @click="$emit('delete', selectedPresetId)"
    />

    <Dialog
      v-model:visible="saveDialogVisible"
      header="Save filter preset"
      modal
      :style="{ width: 'min(92vw, 360px)' }"
      :draggable="false"
    >
      <InputText v-model="presetName" class="w-full" placeholder="Preset name" @keydown.enter="confirmSave" />
      <template #footer>
        <Button label="Cancel" severity="secondary" text @click="saveDialogVisible = false" />
        <Button label="Save" icon="pi pi-save" :loading="savingPreset" @click="confirmSave" />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import Select from 'primevue/select';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';

defineOptions({ name: 'FilterPresetsControl' });

const props = defineProps({
  presets: { type: Array, default: () => [] },
  selectedPresetId: { type: String, default: null },
  loadingPresets: { type: Boolean, default: false },
  savingPreset: { type: Boolean, default: false }
});

const emit = defineEmits(['apply', 'save', 'delete']);

const saveDialogVisible = ref(false);
const presetName = ref('');

const presetOptions = computed(() =>
  (props.presets || []).map((p) => ({ label: p.name, value: p.presetId }))
);

function confirmSave() {
  emit('save', presetName.value.trim());
  presetName.value = '';
  saveDialogVisible.value = false;
}
</script>

<style scoped>
.filter-presets {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.filter-presets__select {
  min-width: 140px;
}
</style>
